import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import ForgotPassword from '../components/pages/forgot-password';

import Actions from '../actions';
import UserAPI from '../apis/user';

import translations from '../../translations/app-translations';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({
    async submitForgotPassword(formData, token, locale) {
        dispatch(Actions.displayLoader());

        return UserAPI.forgotPassword(formData, token).then(
            (response) => {
                dispatch(Actions.hideLoader());
                return true;
            },
            (error) => {
                const responseMessage = JSON.parse(JSON.stringify(error));
                dispatch(Actions.hideLoader());
                toastr.error(translations[locale].password, responseMessage.response.body.error);
                return false;
            },
        );
    },

});

const ForgotPasswordConnector = connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

export default ForgotPasswordConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/forgot-password-connector.js
 **/